import React from 'react';

const Header = () => {

    return (
        <header>
            <div className="logo">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><title>Monogram</title><path d="M84.89,13.45,79.64,42.68a115.52,115.52,0,0,0-2,21.23c-.44-4.59-1.2-9.19-2.08-13.79L68.15,13.45H56.76L50,46.29C48.77,52.09,47.9,58,47.24,63.91a104.16,104.16,0,0,0-1.86-18.39L39.47,13.45H24.69L16.83,62.9C15.65,69,13.9,73.85,7.66,73.85c-3.28,0-5.69-1.64-7.66-4V84.25a22.6,22.6,0,0,0,10.73,2.3c7.22,0,12.2-3.66,14.61-10.67a72.78,72.78,0,0,0,2.9-12.21l3.53-25.08,7.7,47.87H52.06L59,57.78c1.86-7.66,3.07-12.39,3.72-20.16a82.16,82.16,0,0,0,2.52,18.52C67.71,66.21,70,76.39,72.31,86.46H84.89l15.11-73Z"/></svg>
            </div>
            {/*<Location />*/}
        </header>
    );

};

export default Header;


// WEBPACK FOOTER //
// ./src/js/components/Header.js